// src/components/user/Spare1Tab.jsx
import React from 'react';

function Spare1Tab() {
  return (
    <div className="alert alert-secondary">
      Spare1 tab content placeholder.
    </div>
  );
}

export default Spare1Tab;
